<ambita-cadastre-report-cadastre-info>
  <div class="ambita-cadastre-report__section" id="ambita-cadastre-report__cadastre-info" show="{ data.propertyType }">
    <div class="ambita-cadastre-report__sub-section">
      <h4 class="ambita-cadastre-report__section-title ambita-report-h4">
        { i18n.propertyLookup.titleCadastreInfo }
      </h4>
      <div class="ambita-cadastre-report-clearfix">
        <ul class="ambita-cadastre-report__document-output ambita-cadastre-report__col-wide ambita-report-ul">
          <li>
            <span class="ambita-cadastre-report__document-output-title">{ i18n.propertyLookup.cadastreType }</span>
            <span class="ambita-cadastre-report__document-output-value">{ data.propertyType.text }</span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">{ i18n.propertyLookup.cadastreUnitName }</span>
            <span class="ambita-cadastre-report__document-output-value">{ data.unitName }</span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.cadastreEstablishedDate }
            </span>
            <span class="ambita-cadastre-report__document-output-value">{ data.establishedDate.ddmmyyyy }</span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.cadastreRegistered }
            </span>
            <span class="ambita-cadastre-report__document-output-value">{ booleanWriter(data.isRegisteredLand) }</span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.cadastreAreaNote }
            </span>
            <span class="ambita-cadastre-report__document-output-value">{ getPlotsAreaNotes() }</span>
          </li>
        </ul>

        <ul class="ambita-cadastre-report__document-output ambita-cadastre-report__col-medium ambita-report-ul">
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.cadastreTechnicalRegistered }
            </span>
            <span class="ambita-cadastre-report__document-output-value">
              { booleanWriter(data.isTechnicalRegisteredLand) }
            </span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.cadastreLeasedLand }
            </span>
            <span class="ambita-cadastre-report__document-output-value">
              { booleanWriter(data.hasActiveLeasedLand) }
            </span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.cadastreLandTaxation }
            </span>
            <span class="ambita-cadastre-report__document-output-value">{ formatNumber(data.landTaxation, 2) }</span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">{ i18n.propertyLookup.cadastreFarm }</span>
            <span class="ambita-cadastre-report__document-output-value">
              { booleanWriter(data.agriculturalCadastre) }
            </span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.cadastreGroup }
            </span>
            <span class="ambita-cadastre-report__document-output-value">{ getCadastreIndustryGroup() }</span>
          </li>
        </ul>

        <ul class="ambita-cadastre-report__document-output ambita-cadastre-report__col-medium ambita-report-ul">
          <li>
            <span class="ambita-cadastre-report__document-output-title">{ i18n.propertyLookup.cadastrePlots }</span>
            <span class="ambita-cadastre-report__document-output-value">{ formatNumber(data.numberOfPlots) }</span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.cadastreSectioned }
            </span>
            <span class="ambita-cadastre-report__document-output-value">{ booleanWriter(data.sectioned) }</span>
          </li>
          <li if="{ data.purposeSectioning }">
            <span class="ambita-cadastre-report__document-output-title">{ i18n.propertyLookup.cadastrePurpose }</span>
            <span class="ambita-cadastre-report__document-output-value">{ data.purposeSectioning.text }</span>
          </li>
          <li if="{ data.ownerShare }">
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.cadastreFraction }
            </span>
            <span class="ambita-cadastre-report__document-output-value">{ data.ownerShare }</span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">{ i18n.propertyLookup.cadastreArea }</span>
            <span class="ambita-cadastre-report__document-output-value" if="{data.specifiedArea > 0}">
              { data.specifiedArea } { i18n.propertyLookup.cadastreKVM }
            </span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.cadastreAreaSource }
            </span>
            <span class="ambita-cadastre-report__document-output-value">{ data.areaSource.text }</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="ambita-cadastre-report__sub-section" id="ambita-cadastre-report__cadastre-coordinates"
         if="{ data.coordinates }">
      <h4 class="ambita-cadastre-report__section-title ambita-report-h4">
        { i18n.propertyLookup.cadastreCoordinates }:
      </h4>
      <table class="ambita-cadastre-report__list">
        <thead class="ambita-cadastre-report__header">
        <tr class="ambita-cadastre-report__row">
          <th>{ i18n.propertyLookup.coordSystem }</th>
          <th>{ i18n.propertyLookup.coordX }</th>
          <th>{ i18n.propertyLookup.coordY }</th>
        </tr>
        </thead>
        <tbody>
        <tr class="ambita-cadastre-report__row" each="{ coordinate in data.coordinates }">
          <td>23</td>
          <td>{ coordinate[1] }</td>
          <td>{ coordinate[0] }</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="ambita-cadastre-report__sub-section" id="ambita-cadastre-report__cadastre-unregistered-ownerships">
      <h4 class="ambita-cadastre-report__section-title ambita-report-h4">
        { i18n.propertyLookup.cadastreUnregisteredOwnership }
      </h4>
      <div if="{ getAllUnregisteredOwnerships() }">
        <table class="ambita-cadastre-report__list">
          <thead class="ambita-cadastre-report__header">
          <tr class="ambita-cadastre-report__row">
            <th>{ i18n.propertyLookup.unregisteredOwnershipRole }</th>
            <th>{ i18n.propertyLookup.unregisteredOwnershipId }</th>
            <th>{ i18n.propertyLookup.unregisteredOwnershipOwner }</th>
            <th>{ i18n.propertyLookup.unregisteredOwnershipType }</th>
          </tr>
          </thead>
          <tbody>
          <tr class="ambita-cadastre-report__row" each="{ owner in getMainCadastreUnregisteredOwnerships() }">
            <td>{ owner.cadastreLevel }</td>
            <td>{ owner.organizationNumber || owner.personalNumber || owner.shortPersonalNumber }</td>
            <td>{ owner.name }<br>{ owner.businessAddress || createAddress(owner.location) }</td>
            <td>{ getDsfState(owner.dsfState) || owner.businessType.text }</td>
          </tr>
          <tr class="ambita-cadastre-report__row" each="{ owner in getUnregisteredOwnerships() }">
            <td>{ owner.cadastreLevel }</td>
            <td>{ owner.organizationNumber || owner.personalNumber || owner.shortPersonalNumber }</td>
            <td>{ owner.name }<br>{ owner.businessAddress || createAddress(owner.location) }</td>
            <td>{ getDsfState(owner.dsfState) || owner.businessType.text }</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div if="{ getAllUnregisteredCadastreOwnerships() }">
        <table class="ambita-cadastre-report__list">
          <thead class="ambita-cadastre-report__header">
          <tr class="ambita-cadastre-report__row">
            <th>{ i18n.propertyLookup.unregisteredOwnershipRole }</th>
            <th>{ i18n.propertyLookup.unregisteredOwnershipOwner }</th>
            <th>{ i18n.propertyLookup.ownerFraction }</th>
          </tr>
          </thead>
          <tbody>
          <tr class="ambita-cadastre-report__row" each="{ owner in getMainCadastreUnregisteredCadastreOwnerships() }">
            <td>{ owner.cadastreLevel }</td>
            <td>{ owner.owner }</td>
            <td>{ owner.fraction }</td>
          </tr>
          <tr class="ambita-cadastre-report__row" each="{ owner in getUnregisteredCadastreOwnerships() }">
            <td>{ owner.cadastreLevel }</td>
            <td>{ owner.owner }</td>
            <td>{ owner.fraction }</td>
          </tr>
          </tbody>
        </table>
      </div>
      <p if="{ hasNoKindOfUnregisteredOwnerships }">{ i18n.propertyLookup.unregisteredOwnershipInfo }</p>
    </div>

    <div class="ambita-cadastre-report__sub-section" id="ambita-cadastre-report__cadastre-heritages">
      <h4 class="ambita-cadastre-report__section-title ambita-report-h4">{ i18n.propertyLookup.cadastreHeritage }</h4>
      <p if="{ !data.singleHeritages }">{ i18n.propertyLookup.heritageInfo }</p>
      <p class="ambita-cadastre-report__default-text">{ i18n.propertyLookup.heritageText }</p>
      <ambita-cadastre-report-single-heritages heritages="{ data.singleHeritages }"/>
    </div>

    <div class="ambita-cadastre-report__sub-section" id="ambita-cadastre-report__cadastre-soil-contaminations">
      <h4 class="ambita-cadastre-report__section-title ambita-report-h4">
        { i18n.propertyLookup.cadastreSoilContaminations }
      </h4>
      <div if="{ data.soilContaminations }">
        <div class="ambita-cadastre-report__sub-section--collapsible
                    { ambita-cadastre-report__sub-section--collapsed: data.soilContaminations != 1 }"
             each="{ contamination in data.soilContaminations }">
          <header class="ambita-cadastre-report__sub-section-header" onclick="{ collapse }">
            <i class="ambita-cadastre-report__sub-section-arrow"></i>
            <h5 class="ambita-report-h5">
              <span>{ contamination.registeredDate.ddmmyyyy }</span> { contamination.degreeOfImpactType.text }
            </h5>
          </header>
          <div class="ambita-cadastre-report__sub-section-content ambita-cadastre-report-clearfix">
            <ul class="ambita-cadastre-report__document-output ambita-report-ul">
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.soilContaminationLocalityNumber }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ contamination.localityNumber }</span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.soilContaminationAuthority }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ contamination.authorityType.text }</span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.soilContaminationLocalityName }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ contamination.localityName }</span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.soilContaminationDegreeOfImpact }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { contamination.degreeOfImpactType.code } - { contamination.degreeOfImpactType.text }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.soilContaminationRegisteredDate }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { contamination.registeredDate.ddmmyyyy }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.soilContaminationLastUpdatedDate }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { contamination.lastUpdatedDate.ddmmyyyy }
                </span>
              </li>
              <li>
                <a class="ambita-report-link" target="_blank"
                   href="{ contamination.links.soilContaminationWebpage.href }">
                  { i18n.propertyLookup.soilContaminationLinkText }
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p if="{ !data.soilContaminations }">{ i18n.propertyLookup.soilContaminationsInfo }</p>
      <p class="ambita-cadastre-report__default-text">{ i18n.propertyLookup.soilContaminationText }</p>
    </div>

    <div class="ambita-cadastre-report__sub-section" id="ambita-cadastre-report__cadastre-complaints">
      <h4 class="ambita-cadastre-report__section-title ambita-report-h4">
        { i18n.propertyLookup.cadastreComplaints }
      </h4>
      <table class="ambita-cadastre-report__list" if="{ data.complaints }">
        <thead class="ambita-cadastre-report__header">
        <tr class="ambita-cadastre-report__row">
          <th>{ i18n.propertyLookup.complaintRegisteredDate }</th>
          <th>{ i18n.propertyLookup.complaintConcerns }</th>
          <th>{ i18n.propertyLookup.complaintCadastre }</th>
        </tr>
        </thead>
        <tbody>
        <tr class="ambita-cadastre-report__row" each="{ complaint in data.complaints }">
          <td nowrap="nowrap">{ complaint.registeredDate.ddmmyyyy }</td>
          <td>{ complaint.complaintConcerns }</td>
          <td>
            <div each="{ cadastre in complaint.cadastres }"
                 class="{ ambita-clickable-cadastre: isCadastreClickable(cadastre.ident) }">
              { formatCadastre(cadastre.ident) }
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <p if="{ !data.complaints }">{ i18n.propertyLookup.complaintsInfo }</p>
    </div>

    <div class="ambita-cadastre-report__sub-section" id="ambita-cadastre-report__cadastre-affairs">
      <h4 class="ambita-cadastre-report__section-title ambita-report-h4">{ i18n.propertyLookup.cadastreAffairs }</h4>
      <div if="{ data.affairs }">
        <div class="ambita-cadastre-report__sub-section--collapsible" each="{ affair in data.affairs }">
          <header class="ambita-cadastre-report__sub-section-header" onclick="{ collapse }">
            <i class="ambita-cadastre-report__sub-section-arrow"></i>
            <h5 class="ambita-report-h5">
              <span>{ affair.affairDocumentDate.ddmmyyyy }</span> { affair.typeOfAffair.text }
            </h5>
          </header>
          <div class="ambita-cadastre-report__sub-section-content">
            <div>
              <span class="ambita-cadastre-report__document-output-title">
                { i18n.propertyLookup.affairsDocumentDate }
              </span>
              <span class="ambita-cadastre-report__document-output-value">{ affair.affairDocumentDate.ddmmyyyy }</span>
            </div>
            <div>
              <span class="ambita-cadastre-report__document-output-title">
                { i18n.propertyLookup.affairsRegistryDate }
              </span>
              <span class="ambita-cadastre-report__document-output-value">
                { affair.landRegistryRegisteredDate.ddmmyyyy }
              </span>
            </div>
            <table class="ambita-cadastre-report__list">
              <thead class="ambita-cadastre-report__header">
              <tr class="ambita-cadastre-report__row">
                <th>{ i18n.propertyLookup.affairsRole }</th>
                <th>{ i18n.propertyLookup.affairsCadastre }</th>
                <th class="ambita-text-right">{ i18n.propertyLookup.affairsArea }</th>
                <th>&nbsp;</th>
              </tr>
              </thead>
              <tbody>
              <tr class="ambita-cadastre-report__row" each="{ cadastre in affair.cadastreAffairs }">
                <td>{ cadastre.roleInAffair.text }</td>
                <td class="{ ambita-clickable-cadastre: isCadastreClickable(cadastre.cadastreIdent) }">
                  { formatCadastre(cadastre.cadastreIdent) }
                </td>
                <td class="ambita-text-right">{ cadastre.area }</td>
                <td>&nbsp;</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <p if="{ !data.affairs }">
        { i18n.propertyLookup.affairsInfo }
      </p>
    </div>
  </div>

  <script>
    import './subsections/singleHeritages.tag';
    import { init } from './sectionController';

    init(this);
  </script>
</ambita-cadastre-report-cadastre-info>
